import { render, staticRenderFns } from "./ConsultaPartidoCreatePopUp.vue?vue&type=template&id=2c1bfb9b&"
import script from "./ConsultaPartidoCreatePopUp.vue?vue&type=script&lang=js&"
export * from "./ConsultaPartidoCreatePopUp.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaPartidoCreatePopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VDialog,
  VLayout,
  VSelect,
  VTextField,
  VTextarea,
})
